// Object.defineProperty(exports, "__esModule", { value: true });
import {
  isEmptyObject,
  getCurrentPageID
} from '../appRedux/actions/GlobalMethods'
import {
  // REACT_APP_BUS_SITE_APP,
  BUS_SITE_LOCAL
  // REACT_APP_BUS_SITE_SECOND
} from '../constants/StoreSetting'
import { env } from '../env'
import {
  checkExpiresSub,
  checkUserVerifyPage,
  userLogOut
} from '../appRedux/actions'
import { message } from 'antd'
import configureStore, { history } from '../appRedux/store'
import { PostAppTypes } from '../constants/MobAppConstants'
import { postDataToApp } from '../appRedux/actions/MobAppFn'
// const pageURL = useSelector(({ commonConfigs }) => commonConfigs.getCurrPageURL);
var axios_1 = require('axios')
const {
  REACT_APP_API_ENDPOINT,
  REACT_APP_BUS_SITE_APP,
  REACT_APP_BUS_SITE_SECOND
} = env

// const APIVERSION = '1.0';
const APIVERSIONSS = 'v1'

export const APP_STORE_WEB_URL = `https://[domain]${REACT_APP_BUS_SITE_SECOND}`
export const APP_BASE_WEB_URL = REACT_APP_BUS_SITE_APP
export const APP_BASE_LOCAL_URL = BUS_SITE_LOCAL

// const LOCAL_BASE_URL = "http://localhost:5000/api/";
// // const SERVER_BASE_URL = "http://78.133.116.216:8081/api/";
//NOTE: ALWAYS SET BASE URL IN .env file so that we can change url without rebuilding the code...!
export const BASE_URL = `${REACT_APP_API_ENDPOINT}${APIVERSIONSS}/`

export const BEHAVIOUR_TYPE = {
  POST: 'POST',
  GET: 'GET',
  UPDATE: 'PUT',
  DELETE: 'DELETE'
}
var GATEWAY_REGISTER_USER = '/login/registration'
var GATEWAY_LOGIN = '/login/login'
var GATEWAY_REGISTRATION_DATA = '/login/getRegistration'
var GATEWAY_STOREURLVERIFICATION = '/login/validateRegistration'
var GATEWAY_VALIDATE_EMAIL = '/login/ValidateEmail'
var GATEWAY_STOREEmailVERIFICATION = '/login/emailVerification'
var GATEWAY_GETLANGUAGES = 'store/GetSiteLanguages'
// var GATEWAY_GETMENU = '/store/getmenus'
var GATEWAY_PostProductType = '/product/PostProductType'
var GATEWAY_GET_BRANDS = '/product/GetBrands'
var GATEWAY_PostBrands = '/product/PostBrand'
var GATEWAY_POSTPRODUCTTAGS = '/product/PostProductTags'
var GATEWAY_GETPRODUCTTAGLIST = '/product/GetProductTags'
var GATEWAY_GetSuppliers = '/product/GetSuppliers'
var GATEWAY_PostSuppliers = '/product/PostSuppliers'
var GATEWAY_GET_PRICE_BOOKS = '/product/GetPriceBook'
var GATEWAY_POST_PRICE_BOOKS = '/product/PostPriceBook'
var GATEWAY_POST_DUPLICATE__PRICE_BOOKS = '/product/PostDuplicatePriceBook'
var GATEWAY_POST_ADJUST_PRICE_BOOKS = '/product/PostAdjustPricesPriceBook'
var GATEWAY_GET_SEARCHPROD_BOOK = '/product/SearchBookProducts'
var GATEWAY_GET_PROMOTIONS = '/product/GetPromotions'
var GATEWAY_GETPRODUCTSDATA = '/product/GetProductsData'
var GATEWAY_GETSUBSCRIPTION = '/store/GetSubscriptions'
var GATEWAY_GETLANGUAGES = 'store/GetSiteLanguages'
var GATEWAY_GetProductTypes = '/product/getproducttypes'
var GATEWAY_PostProductType = '/product/PostProductType'
var GATEWAY_GET_BRANDS = '/product/GetBrands'
var GATEWAY_PostSuppliers = '/product/PostSuppliers'
var GATEWAY_POST_PRICE_BOOKS = '/product/PostPriceBook'
var GATEWAY_POST_PPRODUCT_STOCK = '/product/PostStockPurchaseOrder'
var GATEWAY_TRANSFER_PRODUCT_STOCK = '/product/TransferStockProduct'
var GATEWAY_RETURN_PRODUCT = '/product/ReturnStockProduct'
var GATEWAY_LIST_STOCK_PRODUCT = '/product/GetStockProuctList'
var GATEWAY_GET_STOCK_ORDER_DETAILS_LISTING =
  '/product/GetStockOrderDetailsListing'
var GATEWAY_LIST_STOCK_STATUS = '/product/GetStockEnumList'
var GATEWAY_GET_STOCK_DETAIL = '/product/GetStockDetail'
var GATEWAY_GET_COUNTRIES = '/login/GetCountries'
var GATEWAY_ADD_CUSTOMER_GROUP = '/customerservices/PostCustomerGroup'
var GATEWAY_LIST_CUSTOMER_GROUP = '/customerservices/GetCustomerGroup'
var GATEWAY_ADD_CUSTOMER = '/customerservices/PostCustomer'
var GATEWAY_LIST_CUSTOMERS = '/customerservices/ListCustomer'
var GATEWAY_PostMainProduct = '/product/PostMainProduct'
var GATEWAY_POST_PROMOTION = '/product/PostPromotions'
var GATEWAY_POST_USERS = '/setup/AddUpdateUser'
var GATEWAY_GET_USERS = '/setup/GetUserList'
var GATEWAY_GET_MENUS_RIGHTS = '/roles/GetMenuRite'
var GATEWAY_GET_ROLES = '/roles/GetRoles'
var GATEWAY_POST_ROLES = '/roles/AddUpdateRoles'
var GATEWAY_GET_OUTLETS = '/store/GetStoreOutlet'
var GATEWAY_GET_Users_By_ID = '/setup/GetUserListById'
var GATEWAY_POST_Users_INFO = '/setup/UpdateUserData'
var GATEWAY_GET_ROLESRIGHT_By_ID = '/roles/GetMenuRiteAndPermissionById'
var GATEWAY_GET_GENERALBOOKPROD = '/product/GetGeneralPriceBookProd'
var GATEWAY_EDIT_CUSTOMER_DATA = '/customerservices/GetCustomerProfileById'
var GATEWAY_GETPRODUCTCOMMONDETAILSBYPRODUCTID =
  '/product/GetProductCommonDetailsByProductID'
var GATEWAY_GETPRODUCTOTHERSDETAILSBYPRODUCTID =
  '/product/GetProductOtherDetailsByProductID'
var GATEWAY_GETSTORECREDIT_CONFIGURATION =
  '/Setup/GetStoreCreditConfigurationParameter/'
var GATEWAY_UPDATESTORECREDIT_CONFIGURATION =
  '/Setup/UpdateStoreCreditConfiguration'
var GATEWAY_GET_PAYMENTYPELIST = '/Setup/GetPaymentTypeList/'
var GATEWAY_POST_PAYMENTTYPES = '/Setup/SaveUpdatePaymentType'
var GATEWAY_GET_PAYMENTYPE_SPECIFIC_ID = '/Setup/GetPaymentTypeSpecificId'
var GATEWAY_POST_GIFTCARD = '/Setup/UpdateGiftCardConfiguration'
var GATEWAY_GET_GIFTCARD_CONFIG = '/Setup/GetGifCardConfigurationParameter'
var GATEWAY_GET_TAXLIST = '/Setup/GetTaxDetails'
var GATEWAY_POST_TAX = '/Setup/SaveUpdateTaxDetails'
var GATEWAY_GET_OUTLETTAX = '/Setup/GetOutletTaxList'
var GATEWAY_POST_OUTLET = '/Setup/SaveUpdateRegisters'
var GATEWAY_GET_LISTOUTLET = '/Setup/GetOuletAndRegister'
var GATEWAY_GET_SALESTAX_BYID = '/Setup/GetTaxValueById'
var GATEWAY_GET_Users_By_ID = '/setup/GetUserListById'
var GATEWAY_POST_Users_INFO = '/setup/UpdateUserData'
var GATEWAY_GET_ROLESRIGHT_By_ID = '/roles/GetMenuRiteAndPermissionById'
var GATEWAY_GET_GENERALBOOKPROD = '/product/GetGeneralPriceBookProd'

var GATEWAY_GETPRODUCTLIST = '/product/GetProductsList'
var GATEWAY_GETPRODUCTOTHERSDETAILSBYPRODUCTID =
  '/product/GetProductOtherDetailsByProductID'
var GATEWAY_GETPROMOCODES = '/product/GetPromotionCodes'

var GATEWAY_GET_CASHMANAGEMENTS = '/sell/GetCashManagement'
var GATEWAY_POST_CASHMANAGEMENTS = '/sell/PostCashManagement'
var GATEWAY_POST_CASHMANAGEMENTS_INOUT = '/sell/PostCashManageInOut'
var GATEWAY_GET_REGISTERINFO = '/sell/GetRegisterOpenInfo'
var GATEWAY_GET_OUTLET_REGISTERS = '/store/GetOutletReg'
var GATEWAY_GET_CLOSED_REGISTERS = '/sell/GetRegisterClosureInfo'

var GATEWAY_GET_QUICKKEYLAYOUTS = '/sell/GetQuickKeyLayouts'
var GATEWAY_POST_QUICKKEYLAYOUTDETAILS = 'sell/PostQuickKeyLayoutDetails'
var GATEWAY_POST_CREATEDEFAULTQUICKKEYSLAYOUT =
  '/sell/GetDefaultQuickKeysLayout'
var GATEWAY_GET_QUICKKEYLAYOUTDETAILS = '/sell/GetQuickKeyLayoutDetails'
var GATEWAY_POST_QUICKKEYCURRENTLAYOUT = '/sell/PostEnableandCurrentLayout'
var GATEWAY_GET_COLORS = '/sell/GetColors'
var GATEWAY_GET_COMMON_CONFIGs = '/CommonService/GetCommonConfigs'
var GATEWAY_GET_COMMON_LOYALTYCONFIGS = '/setup/GetStoreLoyaltyConfiguration'
var GATEWAY_GET_LOYALTYVALUES = '/setup/GetLoyaltyTableValues'
var GATEWAY_UPDATE_STOREBASIC_INFO = '/setup/UpdateStoreBasicInformation'
var GATEWAY_UPDATE_STOREADDRESS_INFO = '/setup/UpdateStoreAddressInformation'
var GATEWAY_UPDATE_STOREGENERAL_CONFIG = '/setup/UpdateGeneralConfiguration'
var GATEWAY_LISTING_GENERAL_SCREEN = '/setup/GeneralScreenListing'
var GATEWAY_GET_RECEIPTTEMPLATES = '/setup/GetReceiptTemplates'
var GATEWAY_POST_RECEIPTTEMPLATES = '/setup/SaveUpdateTemplates'
var GATEWAY_GET_RECEIPTTEMPLATESTYLES = '/setup/GetReceiptTemplateStyles'
var GATEWAY_GET_SELHISTORY_LISTING = '/sell/GetHistoryListing'
var GATEWAY_GET_SELLHISTORY_DETAILS = '/sell/GetHistoryDetails'
var GATEWAY_POST_VOID_SALE = '/sell/PostSaleVoid'
var GATEWAY_POST_EDIT_SALE = '/sell/SaveEditSale'
var GATEWAY_POST_SEND_RECEIPT_EMAIL = '/sell/SendReceiptEmail'
var GATEWAY_GET_ALL_STORE_USERS = '/sell/GetAllStoreUsers'
var GATEWAY_GET_FILTERED_SALES = '/sell/GetFilteredSale'
var GATEWAY_GET_PRMOCODE_DETAILS = '/product/GetPromotionCodeDetails'
var GATEWAY_GET_SALEPRODUCT_DETAILS = '/sell/GetSaleProductDetails'
var GATEWAY_CREATE_SUBS_REQ = '/payment/subscription/create/request'
var GATEWAY_PAYPAL_PAY_REQ = '/payment/request' //changefrom: /paypal/req
var GATEWAY_PAY_RESPSTATUS_REQ = '/Payment/verify/status'
var GATEWAY_GET_PAYMENT_TYPES = '/payment/gateways/list'
var GATEWAY_GET_USER_SUBSCRIPTION = '/store/GetActiveSubscriptionStatus'
var GATEWAY_GET_CUSTOMER_SEARCH = '/customerservices/SearchCustomer'
var GATEWAY_GET_SALE_PRICEBOOKS = '/sell/GetSalePriceBooksDetails'
var GATEWAY_GET_SALE_PROMOTIONS = '/sell/GetSalePromotionDetails'
var GATEWAY_POST_MAINSALEDATA = '/sell/PostMainSale'
var GATEWAY_GET_PAYMENT_LIST = '/setup/GetPaymentList'
var GATEWAY_POST_LOYALTYCONFIGS = '/setup/UpdateStoreLoyaltyConfiguration'
var GATEWAY_GET_PAY_SUMMARY = '/sell/GetOpenCloseManagement'
var GATEWAY_POST_USER_OUT_REG = '/store/SetUserOutletReg'
var GATEWAY_POST_SALE_ORDER_PAYMENTS = '/sell/AddSalesOrderPayments'
var GATEWAY_POST_MAIN_SALE_STATUS = '/sell/PostMainSaleStatus'
var GATEWAY_GET_SALE_HISTORY_BY_ID = '/sell/GetSalesHistoryByID'
var GATEWAY_GET_FULFILLMENT_LIST = '/product/GetFulfillmentList'
var GATEWAY_GET_FULFILLMENT_DETAIL = '/product/GetFulfillDetail'
var GATEWAY_POST_FULFILLMENT = '/product/PostFulfillmentStatus'
var GATEWAY_POST_MAIN_SALE_DELETE = '/sell/PostMainSaleDelete'
var GATEWAY_GET_DYNAMIC_REPORTS_DATA = '/report/GetDynamicReportsData'
var GATEWAY_POST_GET_GENERATE_SKU = '/product/GetGenerateSKU'
var GATEWAY_POST_GET_CHECK_SKU_AVAILIBILITY = 'product/GetCheckSKUAvailability'
var GATEWAY_POST_INVENTORY_TAKES = '/inventory/PostInventoryTakes'
var GATEWAY_GET_INVENTORY_TAKES_LIST = '/inventory/GetInventoryTakesList'
var GATEWAY_GET_INVENTORY_TAKES_DATA_ByID =
  '/inventory/GetInventoryTakeDataByID'
var GATEWAY_GET_REGCLOSURE_LISTING = '/report/GetRegClosureList'
var GATEWAY_GET_REGCLOSURE_SUMMARY = '/report/GetRegClosureSummary'
var GATEWAY_GET_REGCLOSURE_DETAIL = '/report/GetRegClosureDetail'
var GATEWAY_GET_INVENTORYTAKESITEMS = '/inventory/GetInventoryTakesItems'
var GATEWAY_POST_INVENTORY_TAKES_ITEMS = '/inventory/PostInventoryTakeItems'
var GATEWAY_GET_INVENTORYTAKESANDITEMS_BY_ID =
  '/inventory/GetInventoryTakesandItemsByID'
var GATEWAY_POST_INVENTORY_STATUS_UPDATE =
  '/inventory/PostInventoryStatusUpdate'
var GATEWAY_GET_PRODUCT_IMPORT_URL_GENERATE =
  '/product/GetProductImportTemplateURLandGenerate' //"/product/GetProductImportTempProcess" ///product/GetProductImportTemplateURLandGenerate;
var GATEWAY_POST_PRODUCT_IMPORT = '/product/PostProductImport'
var GATEWAY_POST_PRODUCT_STATUS = '/product/PostProductStatus'
var GATEWAY_POST_PRICE_BOOK_STATUS = '/product/PostPriceBookStatus'
var GATEWAY_POST_TABLE_ACTIVE_STATUS = '/sell/PostTableActiveStatus'
var GATEWAY_POST_DELETE_PRODUCT_BATCH = '/product/DeleteProductBatchDetails'
var GATEWAY_GET_INVENTORY_TAKES_LIST = '/inventory/GetInventoryTakesList'
var GATEWAY_GET_INVENTORY_TAKES_DATA_ByID =
  '/inventory/GetInventoryTakeDataByID'
var GATEWAY_GET_REGCLOSURE_SUMMARY = '/report/GetRegClosureSummary'
var GATEWAY_GET_REGCLOSURE_DETAIL = '/report/GetRegClosureDetail'
var GATEWAY_GET_REPOUT_REGS = '/report/GetOutletsAndRegisters'
var GATEWAY_POST_CUS_CREDIT = '/Sell/PostCustomerStoreCredit'
var GATEWAY_GET_CUS_CREDIT = '/Sell/GetCustomerStoreCredit'
var GATEWAY_GET_VERIFY = '/login/EnvironmentStatus'
var GATEWAY_POST_PRODUCTIMPORTSTATUS = '/product/PostProductImportStatus'
var GATEWAY_GET_LASTPRODUCTIMPORTSTATUS =
  '/product/GetLastProductImportExecutions'
var GATEWAY_GET_STOCK_ORDER_STATUS_TYPE = '/product/GetStockOrderStatusTypes'
var GATEWAY_POST_STOCK_ORDER = '/product/PostStockOrder'
var GATEWAY_GET_STOCK_ORDER_DETAILS = '/product/GetStockOrderDetailsByID'
var GATEWAY_POST_STOCK_ORDER_STATUS = '/product/PostStockOrderStatus'
var GATEWAY_GET_INVENTORY_MOVEMENTS_STATUS =
  '/inventory/GetInventoryMovementStatuses'
var GATEWAY_GET_PRODUCT_INVENTORY_LOGS_LISTING =
  '/report/GetProductInventoryLogsListing'
var GATEWAY_GET_SUB_PERM = '/store/GetSubscriptionPermissions'
var GATEWAY_PROD_DETAIL = '/product/GetProductDetail'
var GATEWAT_REPORTS_BI = '/report/BIReports'
var GATEWAY_GET_BIRETAIL_REPORTS = '/Report/BIRetailReports'
var GATEWAY_GET_STORECREDIT_REPORTS = '/report/GetStoreCreditReport'
var GATEWAY_POST_SELL_ATTRIBUTE_GROUP = '/sell/PostSellAttributeGroup'
var GATEWAY_GET_SELL_ATTRIBUTE_GROUPS = '/sell/GetSellAttributeGroups'
var GATEWAY_POST_SELL_ATTRIBUTE = '/sell/PostSellAttribute'

var GATEWAY_GET_SELL_ATTRIBUTES = '/sell/GetSellAttributes'
var GATEWAY_GET_SELL_ATTRIBUTES_DATA = '/sell/GetSellAttributeData'
var GATEWAY_UPDATE_STORE_CONFIG = '/CommonService/UpdateStoreConfiguration'
var GATEWAY_GET_SALELOG = '/sell/GetSalesLogs'
var GATEWAY_POST_SALELOG = '/sell/PostSalesLogs'

var GATEWAY_GET_CUSTOMER_IMPORT_URL_GENERATE =
  '/customerservices/GetCustomerImportTemplateURLandGenerate'
var GATEWAY_GET_LASTCUSTOMERIMPORTSTATUS =
  '/customerservices/GetLastCustomerImportExecutions'
var GATEWAY_POST_CUSTOMER_IMPORT = '/customerservices/PostCustomerImport'
var GATEWAY_GET_GROUPTAX = '/setup/GetGroupTaxDetails'
var GATEWAY_GET_SALEREPPRINT = '/report/GetRegSaleReport'
var GATEWAY_GET_BIDASHBOARD_REPORTS = '/Report/BIDashboardReports'
var GATEWAY_GET_BIDASHBOARDTOPRECORDS_REPORTS =
  '/Report/BIDashboardTopRecordReports'
var GATEWAY_GET_MAX_NUMERIC_SKU = '/Setup/GetMaxNumericSKU'

var GATEWAY_GET_ORDER_NUMBER_GENERATE = '/Product/GeneratePurchaseOrderNumber'
var GATEWAY_GET_CHECK_IS_ORDER_NUMBER_EXIST = '/Product/CheckIsOrderNumberExist'

var GATEWAY_GET_PRINTING = '/Setup/GetPrinters'
var GATEWAY_POST_PRINTING = '/Setup/PostPrinters'
var GATEWAY_POST_STATUS_TRUST = '/payment/trustly/status'
var GATEWAY_POST_CONTACT = '/store/ContactInfoPost'
var GATEWAY_GET_PB_TEMPLATE =
  '/product/GetPriceBookImportTemplateURLandGenerate'
var GATEWAY_POST_PB_TEMPLATE = '/product/PostPriceBookImport'

var GATEWAY_GET_ORDER_NUMBER_GENERATE = '/Product/GeneratePurchaseOrderNumber'
var GATEWAY_GET_CHECK_IS_ORDER_NUMBER_EXIST = '/Product/CheckIsOrderNumberExist'
var GATEWAY_GET_CHECK_IS_NAME_EXIST = '/Product/IsNameExist'
var GATEWAY_POST_PRINTING = '/Setup/PostPrinters'
var GATEWAY_POST_CONTACT = '/store/ContactInfoPost'
var GATEWAY_GET_ALL_PRODUCTS = '/Product/GetAllProducts'

var GATEWAY_GET_GENERAL_PRODUCT_IMPORT_URL_GENERATE =
  '/Product/GetGeneralProductImportTemplateURLandGenerate'
var GATEWAY_POST_GENERAL_PRODUCT_IMPORT = '/Product/PostGeneralProductImport'
var GATEWAY_GET_ORDER_NUMBER_GENERATE = '/Product/GeneratePurchaseOrderNumber'
var GATEWAY_GET_CHECK_IS_ORDER_NUMBER_EXIST = '/Product/CheckIsOrderNumberExist'
var GATEWAY_GET_CHECK_IS_NAME_EXIST = '/Product/IsNameExist'
var GATEWAY_POST_PRINTING = '/Setup/PostPrinters'
var GATEWAY_POST_CONTACT = '/store/ContactInfoPost'
var GATEWAY_GET_ALL_PRODUCTS = '/Product/GetAllProducts'
var GATEWAY_POST_STORE_CALL_REQ = '/login/RegisterStoreRequest'
var GATEWAY_GET_PAY_TYPES = '/payment/request/register'
var GATEWAY_GET_ENTITIES_SYNC_DATA_COUNT =
  '/CommonService/GetEntitiesSyncDataCount'
var GATEWAY_GET_SALE_OFFLINE_ESS = '/sell/GetSaleOfflineEssentials'
var GATEWAY_GET_ENTITIES_DATA_BY_TABLE_NAME =
  '/CommonService/GetEntitesDataByTableName'
var GATEWAY_POST_SYNC_SALES = '/sell/SaveIndexedSales'
var GATEWAY_POST_REPORT_SETT = '/setup/UpdateReportSettings'
var GATEWAY_GET_FORGETPASS = '/login/ForgetPassword'
var GATEWAY_GET_ATTRIB_SALES = '/sell/GetBriefSaleListing'
var GATEWAY_POST_SAVE_EXCEL = '/report/SaveExcel'
var GATEWAY_POST_EXPORT_B_64 = '/report/ExportBase64'
var GATEWAY_POST_MAIN_SALE_HELPER = '/sell/PostMainSaleHelper'
var GATEWAY_GET_QUICKKEY_LAYOUTS_And_DETAILS =
  '/sell/GetQuickKeyLayoutsAndDetails'
var GATEWAY_GET_DISCOUNTLIST = '/Setup/GetDiscountDetails'
var GATEWAY_GET_DISCOUNT_BYID = '/Setup/GetDiscountById'
var GATEWAY_POST_INV_ADJSTMENT = '/inventory/PostInventoryAdjustment'
var GATEWAY_GET_ACC_REMINDER = '/customerservices/SendAccountReminder'

//Create Instance of Axios with default settings

var axios = axios_1.default.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('adminToken'),
    'Access-Control-Allow-Origin': BASE_URL,
    'Access-Control-Allow-Credentials': true
    // "version": APIVERSION,
  }
})

axios.interceptors.request.use(function (config) {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem('adminToken')
  return config
})
var getToken = function () {
  var token = localStorage.getItem('adminToken')
  return {
    Authorization: 'Bearer ' + token
  }
}
var _get = function (url) {
  return axios.get(url, {
    headers: getToken()
  })
}

const store = configureStore(history)

var _getCustom = function (url, body, behaviour_type) {
  let pageID = getCurrentPageID()
  behaviour_type = behaviour_type ?? BEHAVIOUR_TYPE.GET
  const axiosCustom = axios_1.default.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      //accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X1Auth-SHA': localStorage.getItem('x1AUTH_SHA'),
      'X2Auth-SHB': localStorage.getItem('x1AUTH_SHB'),
      'X-LANG': localStorage.getItem('X-LANG'),
      'X-BEHAVIOUR-TYPE': behaviour_type,
      'X-PAGE-MARK': pageID ?? '',
      'Access-Control-Allow-Origin': BASE_URL,
      'Access-Control-Allow-Credentials': true
      // "version": APIVERSION,
    }
  })

  return axiosCustom.get(url).catch(e => {
    if (!checkUserVerifyPage() && checkExpiresSub() > 0) {
      if (e.response && e.response.status === 401) {
        message.error('Token Expired! Redirecting to Login Page')
        setTimeout(() => {
          store.dispatch(userLogOut('store.getState()'))
        }, 3000)
      } else {
        // message.error('Something is wrong...')
      }
    }
  })
}

var _delete = function (url) {
  return axios.delete(url, {
    headers: getToken()
  })
}
var _post = function (url, data) {
  return axios.post(url, data, {
    headers: getToken()
  })
}

var _postCustom = function (url, data, behaviour_type, pkgFeature) {
  let pageID = getCurrentPageID()
  const dispatch = store.dispatch
  behaviour_type = behaviour_type ?? BEHAVIOUR_TYPE.GET
  const axiosCustom = axios_1.default.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      //accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X1Auth-SHA': localStorage.getItem('x1AUTH_SHA'),
      'X2Auth-SHB': localStorage.getItem('x1AUTH_SHB'),
      'X-LANG': localStorage.getItem('X-LANG'),
      'X-BEHAVIOUR-TYPE': behaviour_type,
      'X-PAGE-MARK': pageID ?? '',
      'Access-Control-Allow-Origin': BASE_URL,
      'Access-Control-Allow-Credentials': true,
      'SF-BEHAVIOUR-TYPE': pkgFeature ? pkgFeature : ''
      // "version": APIVERSION,
    },
    contentType: 'multipart/form-data'
  })
  return axiosCustom.post(url, data).catch(e => {
    if (!checkUserVerifyPage() && checkExpiresSub() > 0) {
      if (e.response && e.response.status === 401) {
        message.error('Token Expired! Redirecting to Login Page')
        setTimeout(() => {
          store.dispatch(userLogOut('store.getState()'))
        }, 3000)
      } else {
        // message.error('Something is wrong...')
      }
    }
  })
}
/**
 * doLogin - Logins user
 *
 * @param {*} body
 * @returns
 */
var doLogin = function (body) {
  return axios.post(GATEWAY_LOGIN, body)
}
var registerUser = function (data) {
  var url = GATEWAY_REGISTER_USER
  return _post(url, data)
}
var getRegistrationData = function () {
  var url = GATEWAY_REGISTRATION_DATA
  return _get(url)
}
var storeURLVerification = function (data) {
  var url = GATEWAY_STOREURLVERIFICATION
  return _post(url, data)
}
var emailDomainVerification = function (data) {
  var url = GATEWAY_VALIDATE_EMAIL
  return _post(url, data)
}

var userVerification = function (data) {
  var url = GATEWAY_STOREEmailVERIFICATION
  return _post(url, data)
}
var getSubscription = function (tokenLess) {
  // console.log(localStorage.getItem('X-LANG'))
  const withoutToken = tokenLess ? '?tokenless=1' : ''
  var url = GATEWAY_GETSUBSCRIPTION + withoutToken
  return _getCustom(url)
}
var getLanguages = function () {
  var url = GATEWAY_GETLANGUAGES
  return _getCustom(url)
}
var getProductTypes = function (data, behaviour) {
  var url = GATEWAY_GetProductTypes
  return _postCustom(url, data, behaviour)
}

var getBrandsData = function (data, behaviour) {
  var url = GATEWAY_GET_BRANDS
  return _postCustom(url, data, behaviour)
}
var addUpdateDeleteProductType = function (data, behaviour) {
  var url = GATEWAY_PostProductType
  return _postCustom(url, data, behaviour)
}

var addUpdateDeleteBrands = function (data, behaviour) {
  var url = GATEWAY_PostBrands
  return _postCustom(url, data, behaviour)
}

var addUpdateDeleteProductTags = function (data, behaviour) {
  var url = GATEWAY_POSTPRODUCTTAGS
  return _postCustom(url, data, behaviour)
}

var getProductTags = function (body, behaviour) {
  var url = GATEWAY_GETPRODUCTTAGLIST
  return _postCustom(url, body, behaviour)
}

var getSuppliers = function (data, behaviour) {
  var url = GATEWAY_GetSuppliers
  return _postCustom(url, data, behaviour)
}
var addUpdateDeleteSupplier = function (data, behaviour) {
  var url = GATEWAY_PostSuppliers
  return _postCustom(url, data, behaviour)
}
var getPriceBookData = function (data, behaviour) {
  var url = GATEWAY_GET_PRICE_BOOKS
  return _postCustom(url, data, behaviour)
}
var addUpdateDeletePriceBook = function (data, behaviour) {
  var url = GATEWAY_POST_PRICE_BOOKS
  return _postCustom(url, data, behaviour)
}

var postDuplicatePriceBook = function (data, behavior) {
  var url = GATEWAY_POST_DUPLICATE__PRICE_BOOKS
  return _postCustom(url, data, behavior)
}

var postAdjustPricesPriceBook = function (data, behavior) {
  var url = GATEWAY_POST_ADJUST_PRICE_BOOKS
  return _postCustom(url, data, behavior)
}

var getBookSearchProd = function (data) {
  var url = GATEWAY_GET_SEARCHPROD_BOOK + data
  return _getCustom(url)
}
var postProductStockOrder = function (data) {
  var url = GATEWAY_POST_PPRODUCT_STOCK
  return _postCustom(url, data)
}

var trnasferProductStock = function (data) {
  var url = GATEWAY_TRANSFER_PRODUCT_STOCK
  return _postCustom(url, data)
}

var returnStockProduct = function (data) {
  var url = GATEWAY_RETURN_PRODUCT
  return _postCustom(url, data)
}

var getStockProductList = function () {
  var url = GATEWAY_LIST_STOCK_PRODUCT
  return _getCustom(url)
}

var getPromotions = function (data, behaviour, featureID) {
  var url = GATEWAY_GET_PROMOTIONS
  return _postCustom(url, data, behaviour, featureID)
}
var getProductsData = function (data, behaviour) {
  var url = GATEWAY_GETPRODUCTSDATA
  return _getCustom(url, data, behaviour)
}

// var getMenusData = function () {
//   if (!checkUserVerifyPage()) {
//     var url = GATEWAY_GETMENU
//     return _getCustom(url)
//   }
// }

var getStockStatusList = function () {
  var url = GATEWAY_LIST_STOCK_STATUS
  return _getCustom(url)
}

var getStockDetail = function (data) {
  var url = GATEWAY_GET_STOCK_DETAIL
  return _postCustom(url, data)
}

var getCountries = function () {
  var url = GATEWAY_GET_COUNTRIES
  return new Promise((resolve, reject) => {
    axios
      .get(url, { headers: { 'X-LANG': 1 } })
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var addCustomerGroup = (body, behaviour) => {
  var url = GATEWAY_ADD_CUSTOMER_GROUP
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var listCustomerGroup = (body, behaviour) => {
  var url = GATEWAY_LIST_CUSTOMER_GROUP
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var addCustomer = (body, behaviour) => {
  var url = GATEWAY_ADD_CUSTOMER
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var listCustomer = (body, behaviour) => {
  var url = GATEWAY_LIST_CUSTOMERS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var addUpdateDeleteProduct = function (data, behaviour) {
  var url = GATEWAY_PostMainProduct
  return _postCustom(url, data, behaviour)
}
var getProductList = (data, behaviour) => {
  var url = GATEWAY_GETPRODUCTLIST
  return _postCustom(url, data, behaviour)
}

var getProductCommonDetailByProductID = (data, behaviour) => {
  var url = GATEWAY_GETPRODUCTCOMMONDETAILSBYPRODUCTID
  return _postCustom(url, data, behaviour)
}
var getProductOtherDetailByProductID = (data, behaviour) => {
  var url = GATEWAY_GETPRODUCTOTHERSDETAILSBYPRODUCTID
  return _postCustom(url, data, behaviour)
}

var addUpdateDeletePromotion = function (data, behaviour, featureID) {
  var url = GATEWAY_POST_PROMOTION
  return _postCustom(url, data, behaviour, featureID)
}

var postUsers = function (data, behaviour, pkgFeatureID) {
  var url = GATEWAY_POST_USERS
  return _postCustom(url, data, behaviour, pkgFeatureID ? pkgFeatureID : '')
}

var getUserList = function (body, behaviour) {
  var url = GATEWAY_GET_USERS
  return _getCustom(url, body, behaviour)
}

var getMenusRights = function (body, behaviour) {
  var url = GATEWAY_GET_MENUS_RIGHTS
  return _getCustom(url, body, behaviour)
}

var getRolesList = function (body, behaviour) {
  var url = GATEWAY_GET_ROLES
  return _getCustom(url, body, behaviour)
}

var postRoles = function (data, behaviour, featureID) {
  var url = GATEWAY_POST_ROLES
  return _postCustom(url, data, behaviour, featureID ? featureID : '')
}

var getStoreOutlets = function (isUser) {
  var url =
    isUser == true ? GATEWAY_GET_OUTLETS + '?isuser=true' : GATEWAY_GET_OUTLETS
  return _getCustom(url)
}

var getUserByID = function (id, behaviour) {
  var url = GATEWAY_GET_Users_By_ID
  return _postCustom(url, id, behaviour)
}

var postUsersInfo = function (data, behaviour) {
  var url = GATEWAY_POST_Users_INFO
  return _postCustom(url, data, behaviour)
}

var getRoleRightsByID = function (id, behaviour) {
  var url = GATEWAY_GET_ROLESRIGHT_By_ID
  return _postCustom(url, id, behaviour)
}

var getGeneralBookProd = function (id) {
  var url = GATEWAY_GET_GENERALBOOKPROD
  return _postCustom(url, id)
}

var getPromoCodes = function (data, behaviour) {
  var url = GATEWAY_GETPROMOCODES
  return _postCustom(url, data, behaviour)
}

var getCashManagementService = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_CASHMANAGEMENTS, body, behaviour)
      .then(res => {
        resolve(res.data.data)
        // const data = res.data.data.map((e, index) => {
        // 	return {
        // 		id: index
        // 	};
        // });
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getRegisterInfoService = function (body) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_REGISTERINFO, body)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postCashManagementService = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_CASHMANAGEMENTS, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postCashManagementInOutService = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_CASHMANAGEMENTS_INOUT, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getQuickKeyLayouts = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_QUICKKEYLAYOUTS, body)
      .then(res => {
        resolve(res.data, behaviour)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getOutletsRegistersService = function (body) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_OUTLET_REGISTERS, body)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getDataForCustomerEdit = function (body, behaviour) {
  var url = GATEWAY_EDIT_CUSTOMER_DATA
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getStoreCreditConfiguration = function (body, behaviour) {
  var url = GATEWAY_GETSTORECREDIT_CONFIGURATION
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var updateStoreConfiguration = function (body, behaviour) {
  var url = GATEWAY_UPDATESTORECREDIT_CONFIGURATION
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getStoreOutletPromise = function (body, behaviour) {
  var url = GATEWAY_GET_OUTLETS
  return new Promise((resolve, reject) => {
    _getCustom(url, body, behaviour)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getPaymentTypeList = function (body, behaviour) {
  var url = GATEWAY_GET_PAYMENTYPELIST
  return new Promise((resolve, reject) => {
    _getCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else reject(res.data.msgCode)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var saveUpdatePaymentTypes = function (body, behaviour) {
  var url = GATEWAY_POST_PAYMENTTYPES
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else reject(res.data.msgCode)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getPaymentTypeSpecificId = function (body, behaviour) {
  var url = GATEWAY_GET_PAYMENTYPE_SPECIFIC_ID
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else reject(res.data.msgCode)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var updateGiftCardConfiguration = function () {
  var url = GATEWAY_POST_GIFTCARD
  return new Promise((resolve, reject) => {
    _postCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else reject(res.data.msgCode)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getGiftCardConfiguration = function () {
  var url = GATEWAY_GET_GIFTCARD_CONFIG
  return new Promise((resolve, reject) => {
    _postCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else reject(res.data.msgCode)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getTaxList = function (body, behaviour) {
  var url = `${GATEWAY_GET_TAXLIST}${
    body && body == '1' ? '?isTaxScreen=1' : ''
  }`
  return new Promise((resolve, reject) => {
    _postCustom(url, undefined, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postTax = function (body, behaviour) {
  var url = GATEWAY_POST_TAX
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getOutletTax = function (body, behaviour) {
  var url = GATEWAY_GET_OUTLETTAX
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postOutletAndRegister = function (body, behaviour) {
  var url = GATEWAY_POST_OUTLET
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getOutletAndRegister = function (body, behaviour) {
  var url = GATEWAY_GET_LISTOUTLET
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getSalesTaxById = function (body, behaviour) {
  var url = GATEWAY_GET_SALESTAX_BYID
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getClosedRegInfoService = function (body) {
  var url = GATEWAY_GET_CLOSED_REGISTERS
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postQuickKeylayoutData = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_QUICKKEYLAYOUTDETAILS, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postCreateDefaultQuickKeylayoutData = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_CREATEDEFAULTQUICKKEYSLAYOUT, body, behaviour)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getQuickKeyLayoutDetails = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_QUICKKEYLAYOUTDETAILS, body, behaviour)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postQuickKeyCurrentLayoutData = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_QUICKKEYCURRENTLAYOUT, body, behaviour)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getColors = function (body) {
  return new Promise((resolve, reject) => {
    _getCustom(GATEWAY_GET_COLORS)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getCommonConfigs = function (body) {
  var url = GATEWAY_GET_COMMON_CONFIGs
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getLoyaltyConfigs = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_COMMON_LOYALTYCONFIGS, body, behaviour)
      .then(res => {
        resolve(res.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getLoyaltyValues = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_GET_LOYALTYVALUES, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var updateStoreBasicInfo = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_UPDATE_STOREBASIC_INFO, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var updateStoreAddressInfo = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_UPDATE_STOREADDRESS_INFO, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var updateStoreGeneralConfig = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_UPDATE_STOREGENERAL_CONFIG, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getGeneralScreenList = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_LISTING_GENERAL_SCREEN, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postReceiptTemplatesService = function (body, behaviour) {
  var url = GATEWAY_POST_RECEIPTTEMPLATES
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getReceiptTemplatesService = function (body, behaviour) {
  var url = GATEWAY_GET_RECEIPTTEMPLATES
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getTemplateStyleService = function (body, behaviour) {
  var url = GATEWAY_GET_RECEIPTTEMPLATESTYLES
  return new Promise((resolve, reject) => {
    _getCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getHistoryListingService = function (body, behaviour) {
  var url = GATEWAY_GET_SELHISTORY_LISTING
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getHistoryDetailsService = function (data, behaviour) {
  var url = GATEWAY_GET_SELLHISTORY_DETAILS
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postVoidSaleService = function (data, behaviour) {
  var url = GATEWAY_POST_VOID_SALE
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postEditSaleService = function (data, behaviour) {
  var url = GATEWAY_POST_EDIT_SALE
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postSendReceiptEmailService = function (data, behaviour) {
  var url = GATEWAY_POST_SEND_RECEIPT_EMAIL
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getStoreUsersService = function () {
  var url = GATEWAY_GET_ALL_STORE_USERS
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getFilteredSalesService = function (data, behaviour) {
  var url = GATEWAY_GET_FILTERED_SALES
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getPromoCodeDetailsService = function (data, behaviour) {
  var url = GATEWAY_GET_PRMOCODE_DETAILS
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getSaleProductDetailsService = function (data) {
  var url = GATEWAY_GET_SALEPRODUCT_DETAILS
  return new Promise((resolve, reject) => {
    _postCustom(url, data)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var createSubPaymentReqService = function (data) {
  var url = GATEWAY_CREATE_SUBS_REQ
  return new Promise((resolve, reject) => {
    _postCustom(url, data)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var createPayPalReqService = function (
  gateway,
  mode,
  id,
  amount,
  paymentTypeID
) {
  var url = `${GATEWAY_PAYPAL_PAY_REQ}/${gateway}/${mode}/${id}/${amount}/${paymentTypeID}`
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
        // resolve(res)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var payRespStatusReqService = function (storeID, sessionID) {
  var url = `${GATEWAY_PAY_RESPSTATUS_REQ}/${storeID}/${sessionID}`
  return new Promise((resolve, reject) => {
    _postCustom(url)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getCommonPaymentTypesService = function (main, behaviour) {
  var url = `${GATEWAY_GET_PAYMENT_TYPES}/${main}`
  return new Promise((resolve, reject) => {
    _postCustom(url, '', behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getUserSubscriptionService = function () {
  var url = GATEWAY_GET_USER_SUBSCRIPTION
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getCustomerSearchService = function (body) {
  var url = GATEWAY_GET_CUSTOMER_SEARCH
  return _postCustom(url, body)
}

var getSalePriceBooksService = function (outletid) {
  var url = `${GATEWAY_GET_SALE_PRICEBOOKS}/${outletid}`
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getSalePromotionsService = function (outletid) {
  var url = `${GATEWAY_GET_SALE_PROMOTIONS}/${outletid}`
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postMainSaleProductData = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_MAINSALEDATA, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postMainSaleHELPER = function (body, behaviour) {
  return new Promise((resolve, reject) => {
    _postCustom(GATEWAY_POST_MAIN_SALE_HELPER, body, behaviour)
      .then(res => {
        resolve(res.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getPayListService = function (body, behaviour) {
  var url = GATEWAY_GET_PAYMENT_LIST
  return new Promise((resolve, reject) => {
    _getCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postLoyaltyConfigsService = function (body, behaviour) {
  var url = GATEWAY_POST_LOYALTYCONFIGS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getOpenClosePayService = function (body, methodType) {
  var url = GATEWAY_GET_PAY_SUMMARY
  return new Promise((resolve, reject) => {
    _postCustom(url, body, methodType)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postUserOutRegService = function (body) {
  var url = GATEWAY_POST_USER_OUT_REG
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var postSalePaymentData = function (body, behaviour, from) {
  console.log('pay call from ---->' + from)
  var url = GATEWAY_POST_SALE_ORDER_PAYMENTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var postMainSaleStatus = function (body) {
  var url = GATEWAY_POST_MAIN_SALE_STATUS
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getSaleHistoryByIdService = function (data, behaviour) {
  var url = GATEWAY_GET_SALE_HISTORY_BY_ID
  return new Promise((resolve, reject) => {
    _postCustom(url, data, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getFulfillmentList = function (body) {
  var url = GATEWAY_GET_FULFILLMENT_LIST
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postMainSaleDeleteService = function (body, behaviour) {
  var url = GATEWAY_POST_MAIN_SALE_DELETE
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getFulfillmentDetailService = function (body) {
  var url = GATEWAY_GET_FULFILLMENT_DETAIL
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postFulfillmentService = function (body) {
  var url = GATEWAY_POST_FULFILLMENT
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getDynamicReportsDataService = function (body, featureID) {
  var url = GATEWAY_GET_DYNAMIC_REPORTS_DATA
  return new Promise((resolve, reject) => {
    _postCustom(url, body, false, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getAutoGeneratedSKUs = function (body, behaviour) {
  var url = GATEWAY_POST_GET_GENERATE_SKU
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getCheckSKUAvailability = function (body, behaviour) {
  var url = GATEWAY_POST_GET_CHECK_SKU_AVAILIBILITY
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postInventoryCountData = function (data, behavior, featureID) {
  var url = GATEWAY_POST_INVENTORY_TAKES
  return _postCustom(url, data, behavior, featureID ? featureID : '')
}

var getInventoryDataByID = function (body, behaviour, featureID) {
  var url = GATEWAY_GET_INVENTORY_TAKES_DATA_ByID
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getInventoryListData = function (body, behavior, featureID) {
  var url = GATEWAY_GET_INVENTORY_TAKES_LIST
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getRegClosureLisitng = function (body, behaviour, featureID) {
  var url = GATEWAY_GET_REGCLOSURE_LISTING
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getRegClosureSummary = function (body, behaviour, featureID) {
  var url = GATEWAY_GET_REGCLOSURE_SUMMARY
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getRegClosureDetail = function (body, behaviour, featureID) {
  var url = GATEWAY_GET_REGCLOSURE_DETAIL
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getInventoryTakesItems = function (body, behavior, featureID) {
  var url = GATEWAY_GET_INVENTORYTAKESITEMS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postInventoryTakesItemsDataService = function (data, behavior, featureID) {
  var url = GATEWAY_POST_INVENTORY_TAKES_ITEMS
  return _postCustom(url, data, behavior, featureID)
}

var getInventoryTakesandItemsByID = function (body, behavior, featureID) {
  var url = GATEWAY_GET_INVENTORYTAKESANDITEMS_BY_ID
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var PostInventoryStatusUpdateDataService = function (
  data,
  behavior,
  featureID
) {
  var url = GATEWAY_POST_INVENTORY_STATUS_UPDATE
  return _postCustom(url, data, behavior, featureID)
}

var getRepOutRegs = function (body, behaviour, featureID) {
  var url = GATEWAY_GET_REPOUT_REGS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postCusStoreCredit = function (body, behaviour) {
  var url = GATEWAY_POST_CUS_CREDIT
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getProductTemplateURL = function (behavior) {
  var url = GATEWAY_GET_PRODUCT_IMPORT_URL_GENERATE
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var postProductImportExcel = function (data, behavior) {
  var url = GATEWAY_POST_PRODUCT_IMPORT
  return _postCustom(url, data, behavior)
}

var postProductStatusData = function (data, behavior) {
  var url = GATEWAY_POST_PRODUCT_STATUS
  return _postCustom(url, data, behavior)
}

var postDeleteProductBatchByID = function (data, behavior) {
  var url = GATEWAY_POST_DELETE_PRODUCT_BATCH
  return _postCustom(url, data, behavior)
}

var getCusStoreCreditService = function (body, behaviour) {
  var url = GATEWAY_GET_CUS_CREDIT
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behaviour)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getVerificationService = function (data) {
  var url = GATEWAY_GET_VERIFY
  return _post(url, data)
}
var postProductImportStatusData = function (data, behavior) {
  var url = GATEWAY_POST_PRODUCTIMPORTSTATUS
  return _postCustom(url, data, behavior)
}
var getLastProductExecStatus = function (behavior) {
  var url = GATEWAY_GET_LASTPRODUCTIMPORTSTATUS
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getStockOrdersListing = function (data, behavior, featureID) {
  var url = GATEWAY_GET_STOCK_ORDER_DETAILS_LISTING
  return _postCustom(url, data, behavior, featureID)
}
var getStockOrderStatusTypes = function (behavior) {
  var url = GATEWAY_GET_STOCK_ORDER_STATUS_TYPE
  return _getCustom(url, '', behavior)
}

var postStockOrder = function (data, behavior, featureID) {
  var url = GATEWAY_POST_STOCK_ORDER
  return _postCustom(url, data, behavior, featureID)
}
var getStockOrderDetails = function (data, behavior) {
  var url = GATEWAY_GET_STOCK_ORDER_DETAILS
  return _postCustom(url, data, behavior)
}
var postStockOrderStatus = function (data, behavior) {
  var url = GATEWAY_POST_STOCK_ORDER_STATUS
  return _postCustom(url, data, behavior)
}
var getInventorymovementStatusesService = function (behavior) {
  var url = GATEWAY_GET_INVENTORY_MOVEMENTS_STATUS
  return _getCustom(url, '', behavior)
}
var getProductMovementsListingService = function (data, behavior) {
  var url = GATEWAY_GET_PRODUCT_INVENTORY_LOGS_LISTING
  return _postCustom(url, data, behavior)
}
var getSubPermissionService = function (behavior) {
  var url = GATEWAY_GET_SUB_PERM
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        // console.log(error)
      })
  })
}

var getProdDetailService = function (body, behavior) {
  var url = GATEWAY_PROD_DETAIL
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getReportsBIService = function (body, behavior, featureID) {
  var url = GATEWAT_REPORTS_BI
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior, featureID)
      .then(res => {
        resolve(res)
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getBIRetailsReportsService = function (body, behavior) {
  var url = GATEWAY_GET_BIRETAIL_REPORTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        resolve(res)
        // if (res.data.msgCode === "GENERAL_SUCCESS") {
        //   resolve(res.data.data);
        // } else {
        //   reject(res.data.msgCode);
        // }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getReportsStoreCredit = function (body, behavior, featureID) {
  var url = GATEWAY_GET_STORECREDIT_REPORTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior, featureID)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var addUpdateDeleteSellAttributeGroup = function (data, behaviour) {
  var url = GATEWAY_POST_SELL_ATTRIBUTE_GROUP
  return _postCustom(url, data, behaviour)
}

var getSellAttributeGroups = (data, behaviour) => {
  var url = GATEWAY_GET_SELL_ATTRIBUTE_GROUPS
  return _postCustom(url, data, behaviour)
}

var addUpdateDeleteSellAttribute = function (data, behaviour) {
  var url = GATEWAY_POST_SELL_ATTRIBUTE
  return _postCustom(url, data, behaviour)
}
var getSellAttributes = (data, behaviour) => {
  var url = GATEWAY_GET_SELL_ATTRIBUTES
  return _postCustom(url, data, behaviour)
}
var getSellAttributesService = function (body, behavior) {
  var url = GATEWAY_GET_SELL_ATTRIBUTES_DATA
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        // console.log(error)
      })
  })
}

var updateStoreConfigService = function (body, behavior) {
  var url = GATEWAY_UPDATE_STORE_CONFIG
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getSaleLogsService = function (body, behavior) {
  var url = GATEWAY_GET_SALELOG
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var postSaleLogsService = function (body, behavior) {
  var url = GATEWAY_POST_SALELOG
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        // console.log(error)
      })
  })
}

var getSaleGroupTaxService = function (body, behavior) {
  var url = GATEWAY_GET_GROUPTAX
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        // console.log(error)
      })
  })
}
var getCustomerTemplateURL = function (behavior) {
  var url = GATEWAY_GET_CUSTOMER_IMPORT_URL_GENERATE
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getLastCustomerExecStatus = function (isPB, behavior) {
  var url = `${GATEWAY_GET_LASTCUSTOMERIMPORTSTATUS}${isPB ? '?isPB=1' : ''}`
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var postCustomerImportExcel = function (data, behavior) {
  var url = GATEWAY_POST_CUSTOMER_IMPORT
  return _postCustom(url, data, behavior)
}

var getSaleReportPrintService = function (body, behavior) {
  var url = GATEWAY_GET_SALEREPPRINT
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getBIDashboardReportsService = function (body, behavior) {
  var url = GATEWAY_GET_BIDASHBOARD_REPORTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        resolve(res)
        // if (res.data.msgCode === "GENERAL_SUCCESS") {
        //   resolve(res.data.data);
        // } else {
        //   reject(res.data.msgCode);
        // }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}
var getBIDashboardTopRecordsReportsService = function (body, behavior) {
  var url = GATEWAY_GET_BIDASHBOARDTOPRECORDS_REPORTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body, behavior)
      .then(res => {
        resolve(res)
        // if (res.data.msgCode === "GENERAL_SUCCESS") {
        //   resolve(res.data.data);
        // } else {
        //   reject(res.data.msgCode);
        // }
      })
      .catch(error => {
        reject(error)
        //console.log(error)
      })
  })
}

var getMaxNumericSKU = function () {
  var url = GATEWAY_GET_MAX_NUMERIC_SKU
  return new Promise((resolve, reject) => {
    _getCustom(url)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getOrderNumberGenerate = function (body) {
  var url = GATEWAY_GET_ORDER_NUMBER_GENERATE
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var checkIsOrderNumberExist = function (body) {
  var url = GATEWAY_GET_CHECK_IS_ORDER_NUMBER_EXIST
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getPrintersService = function (body) {
  var url = GATEWAY_GET_PRINTING
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postPrintersService = function (body) {
  var url = GATEWAY_POST_PRINTING
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getSaleOFFEssentials = function (body) {
  var url = GATEWAY_GET_SALE_OFFLINE_ESS
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var getTrustStatusService = function (paymentTypeID, sessionID) {
  var url = `${GATEWAY_POST_STATUS_TRUST}/${paymentTypeID}/${sessionID}`
  return new Promise((resolve, reject) => {
    _postCustom(url)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postContactService = function (body) {
  var url = `${GATEWAY_POST_CONTACT}`
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getAllProductsService = function (body) {
  var url = GATEWAY_GET_ALL_PRODUCTS
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getPBTemplateService = function (body) {
  var url = `${GATEWAY_GET_PB_TEMPLATE}`
  return new Promise((resolve, reject) => {
    _getCustom(url, body)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postPBImportExcel = function (data, id, behavior) {
  var url = `${GATEWAY_POST_PB_TEMPLATE}?pbid=${id}`
  return _postCustom(url, data, behavior)
}

var checkIsNameExist = function (body) {
  var url = GATEWAY_GET_CHECK_IS_NAME_EXIST
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getGeneralProductImportTemplateURLandGenerate = function (behavior) {
  var url = GATEWAY_GET_GENERAL_PRODUCT_IMPORT_URL_GENERATE
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') {
          resolve(res.data.data)
        } else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
        //console.log(error);
      })
  })
}
var postGeneralProductImportExcel = function (data, behavior) {
  var url = GATEWAY_POST_GENERAL_PRODUCT_IMPORT
  return _postCustom(url, data, behavior)
}

var storeCallReqService = function (data) {
  var url = GATEWAY_POST_STORE_CALL_REQ
  return _post(url, data)
}

var getPayTypesNonAuth = function (body) {
  var url = `${GATEWAY_GET_PAY_TYPES}/${body.gateway}/${body.mode}/${
    body.value
  }/${body.amount}/${body.paymentType ? parseInt(body.paymentType) : ''}`
  return new Promise((resolve, reject) => {
    _getCustom(url, body)
      .then(res => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
        // resolve(res)
      })
      .catch(error => {
        reject(error)
      })
  })
}
var getEntitiesDataSyncCount = function (behavior) {
  if (!checkUserVerifyPage()) {
    var url = GATEWAY_GET_ENTITIES_SYNC_DATA_COUNT
    return new Promise((resolve, reject) => {
      _getCustom(url, '', behavior)
        .then(res => {
          if (res.data.msgCode === 'GENERAL_SUCCESS') {
            resolve(res.data.data)
          } else {
            reject(res.data.msgCode)
          }
        })
        .catch(error => {
          reject(error)
          //console.log(error);
        })
    })
  }
}

var getEntitiesDataByTableName = function (data, behaviour) {
  var url = GATEWAY_GET_ENTITIES_DATA_BY_TABLE_NAME
  return new Promise((resolve, reject) => {
    _postCustom(url, data)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postSyncSalesService = function (body) {
  var url = GATEWAY_POST_SYNC_SALES
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postReportSettingService = function (body) {
  var url = GATEWAY_POST_REPORT_SETT
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

// var getForgetPassService = function (body) {
//   var url = `${GATEWAY_GET_FORGETPASS}/${body}`
//   return new Promise((resolve, reject) => {
//     _getCustom(url)
//       .then(res => {
//         if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
//         else {
//           reject(res.data.msgCode)
//         }
//       })
//       .catch(error => {
//         reject(error)
//       })
//   })
// }

var getForgetPassService = function (body) {
  return axios.get(`${GATEWAY_GET_FORGETPASS}/${body}`, {
    headers: {
      'Content-Type': 'application/json',
      'X-STORE-HASH': localStorage.getItem('storeHash')
        ? localStorage.getItem('storeHash').toString()
        : '',
      'X-STORE-NAME': localStorage.getItem('storeName')
        ? localStorage.getItem('storeName').toString()
        : '',
      //"X-DATA-HASH": localStorage.getItem("storeDataHash") ? localStorage.getItem("storeDataHash").toString() : "",
      'X-LANG': 1
    }
  })
}

var getBriefSaleService = function (body) {
  var url = GATEWAY_GET_ATTRIB_SALES
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postSaveExcelService = function (body) {
  var url = GATEWAY_POST_SAVE_EXCEL
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        resolve(res)
        // if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        // else {
        //   reject(res.data.msgCode)
        // }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postExport_B_Service = function (body, featureID) {
  var url = GATEWAY_POST_EXPORT_B_64
  return new Promise((resolve, reject) => {
    _postCustom(url, body, false, featureID)
      .then(res => {
        resolve(res)
        // if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        // else {
        //   reject(res.data.msgCode)
        // }
      })
      .catch(error => {
        reject(error)
      })
  })
}
var postPricebookStatusData = function (data, behavior) {
  var url = GATEWAY_POST_PRICE_BOOK_STATUS
  return _postCustom(url, data, behavior)
}

var getSalesDiscountList = function (body, behaviour) {
  debugger
  var url = `${GATEWAY_GET_DISCOUNTLIST}${
    body && body == '1' ? '?isTaxScreen=1' : ''
  }`
  // return new Promise((resolve, reject) => {
  //   _postCustom(url, undefined, behaviour)
  //     .then(res => {
  //       if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
  //       else {
  //         reject(res.data.msgCode)
  //       }
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  // })
  return new Promise((resolve, reject) => {
    fetch('/sales_discount.json') // Update this path to the actual path of your JSON file
      .then(response => {
        debugger
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error.message)
      })
  })
}

var getSalesDiscountById = function (body, behaviour) {
  debugger
  var url = GATEWAY_GET_DISCOUNT_BYID
  debugger
  return new Promise((resolve, reject) => {
    fetch('/sales_discount.json') // Update this path to the actual path of your JSON file
      .then(response => {
        debugger
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        debugger
        const discountList = data.filter(
          item => item.salesDiscSId === body.SalesDiscountID
        )

        if (discountList.length > 0) {
          console.log(discountList)
          resolve(discountList[0]) // Assuming we only want the first match
        } else {
          reject('Sales discount not founds')
        }
      })
      .catch(error => {
        reject(error.message)
      })
  })

  // return new Promise((resolve, reject) => {
  //   _postCustom(url, body, behaviour)
  //     .then(res => {
  //       if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
  //       else {
  //         reject(res.data.msgCode)
  //       }
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  // })
}

var postTableActiveStatusData = function (data, behavior) {
  var url = GATEWAY_POST_TABLE_ACTIVE_STATUS
  return _postCustom(url, data, behavior)
}
var getQuickKeyLayoutAllDetails = function (behavior) {
  var url = GATEWAY_GET_QUICKKEY_LAYOUTS_And_DETAILS
  return new Promise((resolve, reject) => {
    _getCustom(url, '', behavior)
      .then(res => {
        resolve(res.data, behavior)
      })
      .catch(error => {
        reject(error)
      })
  })
}

var postInvAdjustmentService = function (body) {
  var url = GATEWAY_POST_INV_ADJSTMENT
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

var sendAccReminderEmail = function (body) {
  var url = GATEWAY_GET_ACC_REMINDER
  return new Promise((resolve, reject) => {
    _postCustom(url, body)
      .then(res => {
        if (res.data.msgCode === 'GENERAL_SUCCESS') resolve(res.data.data)
        else {
          reject(res.data.msgCode)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  doLogin: doLogin,
  registerUser: registerUser,
  getRegistrationData: getRegistrationData,
  storeURLVerification: storeURLVerification,
  emailDomainVerification: emailDomainVerification,
  userVerification: userVerification,
  getSubscription: getSubscription,
  getLanguages: getLanguages,
  getProductTypes: getProductTypes,
  addUpdateDeleteProductType: addUpdateDeleteProductType,
  getBrandsData: getBrandsData,
  addUpdateDeleteBrands: addUpdateDeleteBrands,
  addUpdateDeleteProductTags: addUpdateDeleteProductTags,
  getProductTags: getProductTags,
  getSuppliers: getSuppliers,
  addUpdateDeleteSupplier: addUpdateDeleteSupplier,
  addUpdateDeleteBrands: addUpdateDeleteBrands,
  getPriceBookData: getPriceBookData,
  addUpdateDeletePriceBook: addUpdateDeletePriceBook,
  getBookSearchProd: getBookSearchProd,
  postProductStockOrder: postProductStockOrder,
  trnasferProductStock: trnasferProductStock,
  returnStockProduct: returnStockProduct,
  getStockProductList: getStockProductList,
  getStockStatusList: getStockStatusList,
  getPromotions: getPromotions,
  getProductsData: getProductsData,
  getStockDetail: getStockDetail,
  getCountries: getCountries,
  addCustomerGroup: addCustomerGroup,
  listCustomerGroup: listCustomerGroup,
  addCustomer: addCustomer,
  listCustomer: listCustomer,
  addUpdateDeleteProduct: addUpdateDeleteProduct,
  addUpdateDeletePromotion: addUpdateDeletePromotion,
  postUsers: postUsers,
  // getMenusData: getMenusData,
  getUserList: getUserList,
  getMenusRights: getMenusRights,
  getRolesList: getRolesList,
  postRoles: postRoles,
  getStoreOutlets: getStoreOutlets,
  getUserByID: getUserByID,
  postUsersInfo: postUsersInfo,
  getRoleRightsByID: getRoleRightsByID,
  getProductList: getProductList,
  getProductCommonDetailByProductID: getProductCommonDetailByProductID,
  getProductOtherDetailByProductID: getProductOtherDetailByProductID,
  getDataForCustomerEdit: getDataForCustomerEdit,
  getGeneralBookProd: getGeneralBookProd,
  getStoreCreditConfiguration: getStoreCreditConfiguration,
  updateStoreConfiguration: updateStoreConfiguration,
  getStoreOutletPromise: getStoreOutletPromise,
  getPaymentTypeList: getPaymentTypeList,
  saveUpdatePaymentTypes: saveUpdatePaymentTypes,
  getPaymentTypeSpecificId: getPaymentTypeSpecificId,
  updateGiftCardConfiguration: updateGiftCardConfiguration,
  getGiftCardConfiguration: getGiftCardConfiguration,
  getTaxList: getTaxList,
  postTax: postTax,
  getOutletTax: getOutletTax,
  postOutletAndRegister: postOutletAndRegister,
  getOutletAndRegister: getOutletAndRegister,
  getGeneralBookProd: getGeneralBookProd,
  getSalesTaxById: getSalesTaxById,
  getGeneralBookProd: getGeneralBookProd,
  getPromoCodes: getPromoCodes,
  getCashManagementService: getCashManagementService,
  getRegisterInfoService: getRegisterInfoService,
  postCashManagementInOutService: postCashManagementInOutService,
  getQuickKeyLayouts: getQuickKeyLayouts,
  postQuickKeylayoutData: postQuickKeylayoutData,
  postCreateDefaultQuickKeylayoutData: postCreateDefaultQuickKeylayoutData,
  getQuickKeyLayoutDetails: getQuickKeyLayoutDetails,
  postQuickKeyCurrentLayoutData: postQuickKeyCurrentLayoutData,
  getColors: getColors,
  postCashManagementService: postCashManagementService,
  getOutletsRegistersService: getOutletsRegistersService,
  getClosedRegInfoService: getClosedRegInfoService,
  getCommonConfigs: getCommonConfigs,
  getLoyaltyConfigs: getLoyaltyConfigs,
  getLoyaltyValues: getLoyaltyValues,
  updateStoreBasicInfo: updateStoreBasicInfo,
  updateStoreAddressInfo: updateStoreAddressInfo,
  getGeneralScreenList: getGeneralScreenList,
  updateStoreGeneralConfig: updateStoreGeneralConfig,

  postReceiptTemplatesService: postReceiptTemplatesService,
  getReceiptTemplatesService: getReceiptTemplatesService,
  getTemplateStyleService: getTemplateStyleService,

  getHistoryListingService: getHistoryListingService,
  getHistoryDetailsService: getHistoryDetailsService,
  postVoidSaleService: postVoidSaleService,
  postEditSaleService: postEditSaleService,
  postSendReceiptEmailService: postSendReceiptEmailService,
  getStoreUsersService: getStoreUsersService,
  getFilteredSalesService: getFilteredSalesService,
  getPromoCodeDetailsService: getPromoCodeDetailsService,

  getSaleProductDetailsService: getSaleProductDetailsService,
  createSubPaymentReqService: createSubPaymentReqService,
  createPayPalReqService: createPayPalReqService,
  payRespStatusReqService: payRespStatusReqService,
  getCommonPaymentTypesService: getCommonPaymentTypesService,

  getUserSubscriptionService: getUserSubscriptionService,
  getCustomerSearchService: getCustomerSearchService,
  getSalePriceBooksService: getSalePriceBooksService,
  getSalePromotionsService: getSalePromotionsService,

  postMainSaleProductData: postMainSaleProductData,

  getPayListService: getPayListService,

  postLoyaltyConfigsService: postLoyaltyConfigsService,
  getOpenClosePayService: getOpenClosePayService,
  postUserOutRegService: postUserOutRegService,
  postSalePaymentData: postSalePaymentData,
  postMainSaleStatus: postMainSaleStatus,
  getSaleHistoryByIdService: getSaleHistoryByIdService,
  postMainSaleDeleteService: postMainSaleDeleteService,

  getFulfillmentList: getFulfillmentList,
  getFulfillmentDetailService: getFulfillmentDetailService,
  postFulfillmentService: postFulfillmentService,

  getDynamicReportsDataService: getDynamicReportsDataService,
  getAutoGeneratedSKUs: getAutoGeneratedSKUs,
  getCheckSKUAvailability: getCheckSKUAvailability,

  postInventoryCountData: postInventoryCountData,
  getInventoryListData: getInventoryListData,
  getInventoryDataByID: getInventoryDataByID,

  getRegClosureLisitng: getRegClosureLisitng,
  getRegClosureDetail: getRegClosureDetail,
  getRegClosureSummary: getRegClosureSummary,

  getInventoryTakesItems: getInventoryTakesItems,
  postInventoryTakesItemsDataService: postInventoryTakesItemsDataService,
  getInventoryTakesandItemsByID: getInventoryTakesandItemsByID,
  PostInventoryStatusUpdateDataService: PostInventoryStatusUpdateDataService,
  getProductTemplateURL: getProductTemplateURL,
  postProductImportExcel: postProductImportExcel,
  postProductStatusData: postProductStatusData,

  getRepOutRegs: getRepOutRegs,
  postCusStoreCredit: postCusStoreCredit,
  getCusStoreCreditService: getCusStoreCreditService,

  getVerificationService: getVerificationService,
  postProductImportStatusData: postProductImportStatusData,
  getLastProductExecStatus: getLastProductExecStatus,

  getStockOrdersListing: getStockOrdersListing,
  getStockOrderStatusTypes: getStockOrderStatusTypes,
  postStockOrder: postStockOrder,
  getStockOrderDetails: getStockOrderDetails,
  postStockOrderStatus: postStockOrderStatus,
  getInventorymovementStatusesService: getInventorymovementStatusesService,
  getProductMovementsListingService: getProductMovementsListingService,
  getSubPermissionService: getSubPermissionService,
  getProdDetailService: getProdDetailService,
  getReportsBIService: getReportsBIService,
  getBIRetailsReportsService: getBIRetailsReportsService,
  getReportsStoreCredit: getReportsStoreCredit,

  addUpdateDeleteSellAttributeGroup: addUpdateDeleteSellAttributeGroup,
  getSellAttributeGroups: getSellAttributeGroups,
  addUpdateDeleteSellAttribute: addUpdateDeleteSellAttribute,
  getSellAttributes: getSellAttributes,
  getSellAttributesService: getSellAttributesService,
  updateStoreConfigService: updateStoreConfigService,

  getSaleLogsService: getSaleLogsService,
  postSaleLogsService: postSaleLogsService,

  getCustomerTemplateURL: getCustomerTemplateURL,
  getLastCustomerExecStatus: getLastCustomerExecStatus,
  postCustomerImportExcel: postCustomerImportExcel,
  getSaleGroupTaxService: getSaleGroupTaxService,

  getSaleReportPrintService: getSaleReportPrintService,
  getBIDashboardReportsService: getBIDashboardReportsService,
  getBIDashboardTopRecordsReportsService:
    getBIDashboardTopRecordsReportsService,
  getMaxNumericSKU: getMaxNumericSKU,
  getOrderNumberGenerate: getOrderNumberGenerate,
  checkIsOrderNumberExist: checkIsOrderNumberExist,

  getPrintersService: getPrintersService,
  postPrintersService: postPrintersService,
  getTrustStatusService: getTrustStatusService,
  postContactService: postContactService,
  postDeleteProductBatchByID: postDeleteProductBatchByID,

  getPBTemplateService: getPBTemplateService,
  postPBImportExcel: postPBImportExcel,

  postDeleteProductBatchByID: postDeleteProductBatchByID,
  getAllProductsService: getAllProductsService,
  checkIsNameExist: checkIsNameExist,
  getGeneralProductImportTemplateURLandGenerate:
    getGeneralProductImportTemplateURLandGenerate,
  postGeneralProductImportExcel: postGeneralProductImportExcel,
  checkIsNameExist: checkIsNameExist,
  storeCallReqService: storeCallReqService,
  getPayTypesNonAuth: getPayTypesNonAuth,

  getSaleOFFEssentials: getSaleOFFEssentials,
  getEntitiesDataSyncCount: getEntitiesDataSyncCount,
  getEntitiesDataByTableName: getEntitiesDataByTableName,

  postSyncSalesService: postSyncSalesService,
  postReportSettingService: postReportSettingService,

  getForgetPassService: getForgetPassService,
  getBriefSaleService: getBriefSaleService,

  postSaveExcelService: postSaveExcelService,
  postExport_B_Service: postExport_B_Service,

  postMainSaleHELPER: postMainSaleHELPER,
  postDuplicatePriceBook: postDuplicatePriceBook,
  postAdjustPricesPriceBook: postAdjustPricesPriceBook,
  postPricebookStatusData: postPricebookStatusData,
  postTableActiveStatusData: postTableActiveStatusData,
  getQuickKeyLayoutAllDetails: getQuickKeyLayoutAllDetails,
  getSalesDiscountList: getSalesDiscountList,
  getSalesDiscountById: getSalesDiscountById,
  postInvAdjustmentService: postInvAdjustmentService,
  sendAccReminderEmail: sendAccReminderEmail
}
//# sourceMappingURL=DataServices.js.map
